namespace JupitersChoice {
    export class OnBaseGameReadyCmd {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('GameStage') _gameStage: Sapphire.GameStage;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('StageLoadModel') _stageLoadModel: Sapphire.StageLoadModel;
        @inject('TranslationsManager') _translationsManager: Sapphire.TranslationsManager;

        execute(): void {
            this._stageLoadModel.addLoadedStage("BaseGame");

            const jupiterBaseGame = this._componentManager.get('JupiterBaseGame');
            this._componentManager.get('JupiterFreeGameLandscape').pause();
            this._componentManager.get('JupiterFreeGamePortrait').pause();
            this._componentManager.get('FreeGameSky').pause();

            this._layerManager.setVisibility('BaseGame', true);
            this._layerManager.setVisibility('BaseGameJupiter', true);
            this._layerManager.setVisibility('FreeGameJupiter', false);

            jupiterBaseGame.changeAnimation('idle', false, true);
            jupiterBaseGame.resume();
            this._componentManager.get('BaseGameSky').changeAnimation('idle', false, true);
            this._componentManager.get('BaseGameSky').play();

            this._componentManager.get('JupiterLightningBolt').rotate((Math.PI / 180) * 90);

            // stop bonus game flames
            for (let i = 1; i < 9; i++) {
                this._componentManager.get(`FreeGameFlame${i}`).hide();
                this._componentManager.get(`FreeGameFlame${i}`).stop();
            }

            // start base game flames
            for (let i = 1; i < 3; i++) {
                this._componentManager.get(`BaseGameFlame${i}`).show();
                this._componentManager.get(`BaseGameFlame${i}`).play();
            }

            // hide the damn reel glows
            TweenMax.delayedCall(0.01,() => {
                for (let i = 3; i < 6; i++) {
                    this._componentManager.get(`ReelGlow${i}`).hide();
                }
            });
        }
    }
}